// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  AdminSetPasswordRequest,
  CliLoginRequest,
  GenericApiResponse,
  GenericApiResponseCliLoginResponse,
  GenericApiResponseLoginResponse,
  GenericApiResponseTokenResponse,
  HTTPValidationError,
  LoginRequest,
  PasswordChangeRequest,
  PasswordResetConfirm,
  PasswordResetRequest,
  RefreshRequest,
} from '../../models';

/**
 * Login user with username/email and password.
 * @summary Login User
 */
export const authLogin = (
  loginRequest: LoginRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseLoginResponse>> => {
  return axios.post(`/auth/login`, loginRequest, options);
};

export const getAuthLoginMutationOptions = <
  TData = Awaited<ReturnType<typeof authLogin>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: LoginRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['authLogin'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogin>>, { data: LoginRequest }> = (props) => {
    const { data } = props ?? {};

    return authLogin(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { data: LoginRequest }, TContext>;
};

export type AuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authLogin>>>;
export type AuthLoginMutationBody = LoginRequest;
export type AuthLoginMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Login User
 */
export const useAuthLogin = <
  TData = Awaited<ReturnType<typeof authLogin>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: LoginRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: LoginRequest }, TContext> => {
  const mutationOptions = getAuthLoginMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Login for CLI clients using tenant id or slug plus username and password.
 * @summary Cli Login
 */
export const authCliLogin = (
  cliLoginRequest: CliLoginRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseCliLoginResponse>> => {
  return axios.post(`/auth/cli/login`, cliLoginRequest, options);
};

export const getAuthCliLoginMutationOptions = <
  TData = Awaited<ReturnType<typeof authCliLogin>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: CliLoginRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['authCliLogin'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authCliLogin>>, { data: CliLoginRequest }> = (props) => {
    const { data } = props ?? {};

    return authCliLogin(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { data: CliLoginRequest }, TContext>;
};

export type AuthCliLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authCliLogin>>>;
export type AuthCliLoginMutationBody = CliLoginRequest;
export type AuthCliLoginMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Cli Login
 */
export const useAuthCliLogin = <
  TData = Awaited<ReturnType<typeof authCliLogin>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: CliLoginRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: CliLoginRequest }, TContext> => {
  const mutationOptions = getAuthCliLoginMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Impersonate another user. Only allowed for admins.
 * @summary Impersonate User
 */
export const authImpersonateUser = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseTokenResponse>> => {
  return axios.post(`/auth/impersonate/${userId}`, undefined, options);
};

export const getAuthImpersonateUserMutationOptions = <
  TData = Awaited<ReturnType<typeof authImpersonateUser>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['authImpersonateUser'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authImpersonateUser>>, { userId: string }> = (props) => {
    const { userId } = props ?? {};

    return authImpersonateUser(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { userId: string }, TContext>;
};

export type AuthImpersonateUserMutationResult = NonNullable<Awaited<ReturnType<typeof authImpersonateUser>>>;

export type AuthImpersonateUserMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Impersonate User
 */
export const useAuthImpersonateUser = <
  TData = Awaited<ReturnType<typeof authImpersonateUser>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string }, TContext> => {
  const mutationOptions = getAuthImpersonateUserMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Set a specific password for a user. Only allowed for admins.
 * @summary Admin Set Password
 */
export const authAdminSetPassword = (
  userId: string,
  adminSetPasswordRequest: AdminSetPasswordRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(`/auth/set-password/${userId}`, adminSetPasswordRequest, options);
};

export const getAuthAdminSetPasswordMutationOptions = <
  TData = Awaited<ReturnType<typeof authAdminSetPassword>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: AdminSetPasswordRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['authAdminSetPassword'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authAdminSetPassword>>,
    { userId: string; data: AdminSetPasswordRequest }
  > = (props) => {
    const { userId, data } = props ?? {};

    return authAdminSetPassword(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; data: AdminSetPasswordRequest },
    TContext
  >;
};

export type AuthAdminSetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authAdminSetPassword>>>;
export type AuthAdminSetPasswordMutationBody = AdminSetPasswordRequest;
export type AuthAdminSetPasswordMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Admin Set Password
 */
export const useAuthAdminSetPassword = <
  TData = Awaited<ReturnType<typeof authAdminSetPassword>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: AdminSetPasswordRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; data: AdminSetPasswordRequest }, TContext> => {
  const mutationOptions = getAuthAdminSetPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Refresh access token using refresh token.
 * @summary Refresh Token
 */
export const authRefreshToken = (
  refreshRequest: RefreshRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseTokenResponse>> => {
  return axios.post(`/auth/refresh`, refreshRequest, options);
};

export const getAuthRefreshTokenMutationOptions = <
  TData = Awaited<ReturnType<typeof authRefreshToken>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: RefreshRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['authRefreshToken'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRefreshToken>>, { data: RefreshRequest }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return authRefreshToken(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { data: RefreshRequest }, TContext>;
};

export type AuthRefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof authRefreshToken>>>;
export type AuthRefreshTokenMutationBody = RefreshRequest;
export type AuthRefreshTokenMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Refresh Token
 */
export const useAuthRefreshToken = <
  TData = Awaited<ReturnType<typeof authRefreshToken>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: RefreshRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: RefreshRequest }, TContext> => {
  const mutationOptions = getAuthRefreshTokenMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Request password reset for user.
 * @summary Forgot Password
 */
export const authForgotPassword = (
  passwordResetRequest: PasswordResetRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(`/auth/forgot-password`, passwordResetRequest, options);
};

export const getAuthForgotPasswordMutationOptions = <
  TData = Awaited<ReturnType<typeof authForgotPassword>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: PasswordResetRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['authForgotPassword'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authForgotPassword>>, { data: PasswordResetRequest }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return authForgotPassword(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: PasswordResetRequest },
    TContext
  >;
};

export type AuthForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authForgotPassword>>>;
export type AuthForgotPasswordMutationBody = PasswordResetRequest;
export type AuthForgotPasswordMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Forgot Password
 */
export const useAuthForgotPassword = <
  TData = Awaited<ReturnType<typeof authForgotPassword>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: PasswordResetRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: PasswordResetRequest }, TContext> => {
  const mutationOptions = getAuthForgotPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Reset user password using reset token.
 * @summary Reset Password
 */
export const authResetPassword = (
  passwordResetConfirm: PasswordResetConfirm,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(`/auth/reset-password`, passwordResetConfirm, options);
};

export const getAuthResetPasswordMutationOptions = <
  TData = Awaited<ReturnType<typeof authResetPassword>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: PasswordResetConfirm }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['authResetPassword'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authResetPassword>>, { data: PasswordResetConfirm }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return authResetPassword(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: PasswordResetConfirm },
    TContext
  >;
};

export type AuthResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authResetPassword>>>;
export type AuthResetPasswordMutationBody = PasswordResetConfirm;
export type AuthResetPasswordMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Reset Password
 */
export const useAuthResetPassword = <
  TData = Awaited<ReturnType<typeof authResetPassword>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: PasswordResetConfirm }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: PasswordResetConfirm }, TContext> => {
  const mutationOptions = getAuthResetPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Change current user's password.
 * @summary Change Password
 */
export const authChangePassword = (
  passwordChangeRequest: PasswordChangeRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(`/auth/change-password`, passwordChangeRequest, options);
};

export const getAuthChangePasswordMutationOptions = <
  TData = Awaited<ReturnType<typeof authChangePassword>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: PasswordChangeRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['authChangePassword'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authChangePassword>>,
    { data: PasswordChangeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return authChangePassword(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: PasswordChangeRequest },
    TContext
  >;
};

export type AuthChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authChangePassword>>>;
export type AuthChangePasswordMutationBody = PasswordChangeRequest;
export type AuthChangePasswordMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Change Password
 */
export const useAuthChangePassword = <
  TData = Awaited<ReturnType<typeof authChangePassword>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: PasswordChangeRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: PasswordChangeRequest }, TContext> => {
  const mutationOptions = getAuthChangePasswordMutationOptions(options);

  return useMutation(mutationOptions);
};
